{
  "search": "Search:",
  "searchText1": "\"403 Forbidden\" login",
  "searchText2": "ClassCastException OR NullPointerException",
  "searchText3": "-level:info",
  "searchText4": "\"'str' object \" -TypeError",
  "timeFrame": "Timeframe:",
  "timeFrameText1": "2 hours ago",
  "timeFrameText2": "friday 10am to friday 11am",
  "findLines1": "Find lines that contain <mark>\"403 Forbidden\"</mark> <strong>and</strong> <mark>\"login\"</mark>.",
  "findLines2": "Find lines that contain <mark>\"ClassCastException\"</mark> <strong>or</strong> <mark>\"NullPointerException\"</mark>.",
  "findLines3": "Exclude lines where the field <mark>LEVEL</mark> is <mark>\"info\"</mark> starting from <mark>2 hours ago</mark>.",
  "findLines4": "Find lines that contain <mark>\"'str' object\"</mark> but <strong>does not</strong> contain <mark>\"TypeError\"</mark> between timeframe <mark>friday 10am to friday 11am</mark>.",
  "terms": "Search terms defaults to <code>AND</code>, unless you specify <code>OR</code> (in caps). Use <code>(</code><code>)</code> grouping for complex <code>AND</code>/<code>OR</code><br>Send us JSON and use: <code>fieldname:keyword</code><br>Timeframe examples: <code>last friday</code>, <code>5:42am</code>, <code>yesterday 1pm</code>, <code>2/24 2:30pm</code>",
  "searchLinkText1": "For a more detailed breakdown on searching ",
  "searchLinkText2": "check out our search guide.",
  "close": "Close, and don't show again"
}
